(ns frontend.view.login.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :login]))
(defonce mobile (r/cursor db/app-state [:mobile]))
(defonce session (r/cursor db/app-state [:session]))
(defonce account (r/cursor db/app-state [:session :account]))
(defonce tenant (r/cursor db/app-state [:session :tenant]))

(defn login-status []
  (-> @state :login-status))
